import styled, { css } from 'styled-components';
import { PillButton } from '../commonStyles';
import { Button } from 'antd';

export const CommonCapsuleStyle = styled(PillButton)`
  margin-left: ${(props) => props.enableLeft};
  margin-top: ${(props) => props.top};
	font-family: ${(props) => props.theme.fontFamily.helveticaNeueMedium};
	font-size: ${(props) => props.fontSize ? props.fontSize : props.theme.fontSize.secondary};
	color: ${(props) => (props.disabled ? props.theme.fontColors.textColor : props.theme.fontColors.primary)};
	background-color: ${(props) =>
		props.whiteBackground
			? props.theme.backgroundColor.layoutLight
			: props.disabled
			? props.theme.backgroundColor.summaryDivider
			: props.theme.backgroundColor.pill};
	height: ${(props) => props.height ? props.height : '30px'} !important;
	padding: ${(props) => props.padding};
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	&:hover,
	&:focus {
		color: ${(props) => (props.disabled ? props.theme.fontColors.textColor : props.theme.fontColors.primary)};
		background-color: ${(props) =>
			props.whiteBackground
				? props.theme.backgroundColor.layoutLight
				: props.disabled
				? props.theme.backgroundColor.summaryDivider
				: props.theme.backgroundColor.pill};
		border-color: ${(props) => props.theme.colors.border};
	}

	border: solid 1px ${(props) => props.theme.border.pill};
	border-radius: 1rem;
	&:disabled {
		background-color: ${(props) => props.theme.backgroundColor.summaryDivider};
	}
	@media only screen and (min-width: 320px) and (max-width: 767px) {
		height: ${(props) => props.mobHeight ? 'auto' : '1.75rem'} !important;
		width: ${(props) => (props.mobWidth || (props.mobHeight ? '248px' : 'auto'))} !important;
		border-radius: ${(props) => props.mobHeight ? '24px' : '1rem'} !important;
		${(props) => props.padding && `padding: props.padding`}
		white-space: ${(props) => props.mobHeight ? 'pre-wrap' : 'nowrap'} !important;
  }
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    ${(props) => props.mobWidth && `width: ${props.mobWidth} !important`};
    ${(props) => props.mobWidth && `min-width: ${props.mobWidth} !important`};
  }
	width: ${(props) => props.width}
	line-height: ${(props) => props.lineHeight}
`;

export const VerticalAlign = styled.span`
	vertical-align: middle;
`;

export const CapsuleIcon = styled.img`
	vertical-align: middle;
	margin-left: 5px;
`;

export const FunctionalBtnStyles = styled(Button)`
	@media only screen and (max-width: ${props => props.maxWidth}) {
		width: ${(props) => (props.mobWidth ? props.mobWidth : 'auto')};
		margin :${(props) => (props.mobMargin ? props.mobMargin : 'auto')};
	}
	width: ${(props) => (props.width ? props.width : 'auto')};
	border-radius: 0px;
	font-family: ${(props) => props.theme.fontFamily.helveticaNeueCondensedBold};
	background-color: ${(props) =>
		props.inverted ? props.theme.backgroundColor.white : props.theme.colors.primaryColor};
  font-size: ${(props) => props.fontSize ? props.fontSize : props.theme.fontSize.primary};
	color: ${(props) => (props.inverted ? props.theme.colors.primaryColor : props.theme.colors.white)};
	font-stretch: ${(props) => props.theme.fontStretch.normal};
	letter-spacing: ${(props) => props.theme.letterSpacing.normal};
	display: flex;
	justify-content: center;
	align-items: center;
	text-transform: uppercase;
	height: 50px;
	border-color: ${(props) => props.theme.colors.primaryColor};
	&:hover,
	:focus {
		${(props) =>
			props.inverted
				? css`
						background-color: ${(props) => props.theme.colors.white} !important;
						color: ${(props) => props.theme.colors.primaryColor};
						border: ${(props) => props.borderHover};
						border-color: ${(props) => props.theme.colors.primaryColor};
				  `
				: css`
						background-color: ${(props) => props.theme.colors.primaryColor};
						color: ${(props) => props.theme.colors.white};
						border: ${(props) => props.borderHover};
						border-color: ${(props) => props.theme.colors.primaryColor};
				  `}
	}
	&[disabled] {
		background-color: ${(props) => props.theme.backgroundColor.summaryDivider};
		border-color: ${(props) => props.theme.border.pill};
		color: ${(props) => props.theme.fontColors.textColor};
		opacity: 0.5;
	}
	&[disabled]:hover,
	&[disabled]:focus {
		background-color: ${(props) => props.theme.backgroundColor.summaryDivider};
		border-color: ${(props) => props.theme.border.pill};
		color: ${(props) => props.theme.fontColors.textColor};
	}
`;

export const FunctionalBtnWrapper = styled(FunctionalBtnStyles)`
	&:hover {
		background-color: ${(props) => props.theme.colors.ctaHover};
	}
	.new_arrow {
		border: 0;
		cursor: pointer;
		padding: 0;
		height: 8px;
		width: 25px;
		outline: none;
		background: transparent;
		display: inline-block;
		${(props) => (props.leftArrow ? 'margin-right: 15px;' : 'margin-left: 15px;')}
		${(props) => props.leftArrow && 'transform: rotate(180deg)'}
	}
	.arrow_line {
		width: 15px;
		height: 2px;
		top: 2px;
		left: 0px;
		position: relative;
		display: block;
		background: ${(props) =>
			props.disabled
				? props.theme.colors.tabHead
				: props.inverted
				? props.theme.colors.primaryColor
				: props.theme.backgroundColor.layoutLight};
		z-index: 1;
		transition: all 0.4s ease-in-out;
	}
	.arrow_line span {
		bottom: -3px;
		right: 0px;
		border: solid
			${(props) =>
				props.disabled
					? props.theme.colors.tabHead
					: props.inverted
					? props.theme.colors.primaryColor
					: props.theme.backgroundColor.layoutLight};
		border-width: 0 2px 2px 0;
		display: inline-block;
		padding: 3px;
		transform: rotate(-45deg);
		-webkit-transform: rotate(-45deg);
		position: absolute;
		z-index: 5;
		transition: all 0.4s ease-in-out;
	}
	&:hover {
		span.arrow_line {
			width: 25px;
			left: 0;
		}
	}

	&:disabled {
		background-color: ${(props) => props.theme.backgroundColor.summaryDivider};
	}
`;
